import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { PrimaryTextXs, GrayTextXs } from 'atoms';
import { Mr2 } from 'wrappers';
import { format } from 'date-fns';
import { Button } from './atoms';

export const template = styled.div`
  ${({ theme }) => css`
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${`${theme?.colour?.primary}0D`};
    border-radius: 8px;
    width: 100%;
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(PrimaryTextXs, Mr2),
      name: 'PrimaryText',
      displayValue: ({ }) => 'Complete'
    },
    {
      component: wrap(GrayTextXs, Mr2),
      name: 'Text',
      displayValue: ({ date, completedBy }) => `${format(date, 'MM/dd/yy hh:mm a')} ${completedBy ? completedBy : ''}`
    },
    {
      component: Button,
      name: 'Reopen',
      displayValue: ({ }) => 'Reopen',
    },
  ]
})